import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "../utils/api";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const { setUser } = useContext(AuthContext);
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        try {
            const res = await axios.post("/auth/login", { username, password });
            setUser(res.data);
            navigate("/");
        } catch (err) {
            setError(err.response?.data?.msg || "Login failed");
        }
    }

    return (
        <div className="auth-page">
            <form className="auth-form" onSubmit={handleSubmit}>
                <h2>Login</h2>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit">Login</button>
                {error && <p className="error-msg">{error}</p>}
                <p>Don't have an account? <a href="/signup">Sign Up</a></p>
            </form>
        </div>
    );
}